export default "__VITE_ASSET__Dx3QeUo0__"